import { init, error, warn, log } from '@appfolio/browser-reporter';
import { RollbarAdapter } from '@appfolio/browser-reporter/adapters/rollbar';
import { DatadogAdapter } from '@appfolio/browser-reporter/adapters/datadog';
import { datadogLogs } from '@datadog/browser-logs';

const adapters = [
  new RollbarAdapter({
    rawRollbarConfig: {
      accessToken: '89362fd03a114efc9d17271cf6f739e1',
      captureUncaught: true,
      captureUnhandledRejections: true,
      payload: {
        environment: process.env.DEPLOYMENT_ENV,
      },
      ignoredMessages: [
        'refused to evaluate a string as javascript',
      ],
      scrubFields: ['magic_link_token'],
    },
  }),
];

if (process.env.DD_CLIENT_TOKEN) {
  datadogLogs.init({
    clientToken: process.env.DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'passport-frontend',
    env: process.env.DEPLOYMENT_ENV,
    forwardErrorsToLogs: false,
  });
  adapters.push(new DatadogAdapter());
}

init(adapters);

export default { error, warn, log };
